import { callPlanet } from './'

// type FetchSaleStock = (
//   saleKey: string,
//   marketId: string,
//   cultureCode: string
// ) => AjaxObservable

export const fetchSaleStock = (
  saleKey,
  marketId,
  cultureCode
) =>
  callPlanet(`stock/unavailable/${saleKey}/${marketId}/${cultureCode}`)

// type FetchProductStock = (
//   saleKey: string,
//   productKey: string,
//   marketId: string,
//   cultureCode: string
// ) => AjaxObservable

export const fetchProductStock = (
  saleKey,
  productKey,
  marketId,
  cultureCode
) =>
  callPlanet(`stock/details/unavailable/${saleKey}/${productKey}/${marketId}/${cultureCode}`)

// type FetchPackageStock = (
//   saleKey: string,
//   productKey: string,
//   marketId: string,
//   cultureCode: string,
//   packageKey: string
// ) => AjaxObservable

export const fetchPackageStock = (
  saleKey,
  productKey,
  packageKey,
  marketId,
  cultureCode
) =>
  callPlanet(`stock/details/unavailable/${saleKey}/${productKey}/${packageKey}/${marketId}/${cultureCode}`)

export const fetchPickersBindingsStock = (
  cultureCode,
  countryCode,
  marketId,
  packageKey,
  productKey,
  saleKey
) => (
  callPlanet(`Pickers/State/${saleKey}/${productKey}/${packageKey}/${marketId}/${countryCode}/${cultureCode}`)
)
